import { Account } from "@/containers/account/Account";

export const User = () => {
  return <Account />;
};
